module.exports = __webpack_public_path__ + "static/img/位图.3a19ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/位图.png
// module id = K1+n
// module chunks = 1